import React from 'react'

const apiUrl = process.env.REACT_APP_API_URL;

export async function insertEmail(email: String) {
    await fetch(`${apiUrl}/database/insert/email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            email: email
        })
    })
}

export async function insertDate() {
    await fetch(`${apiUrl}/database/insert/visit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
    })
}